<template>
  <div
    class="d-flex flex-row align-center flex-grow-1 justify-start justify-sm-end"
  >
    <span class="mr-5 mr-sm-2 d-flex flex-row flex-nowrap">
      <v-icon color="black" style="font-size: 26px;"
        >mdi-account-multiple-check-outline</v-icon
      >
    </span>
    <span class="mr-5 d-flex flex-row flex-nowrap">
      <v-icon color="green" class="mr-1" style="font-size: 20px;"
        >mdi-check</v-icon
      >
      {{ playerInvitesYes.length }}
    </span>
    <span class="mr-5 d-flex flex-row flex-nowrap">
      <v-icon color="red" class="mr-1" style="font-size: 20px;"
        >mdi-close</v-icon
      >
      {{ playerInvitesNo.length }}
    </span>
    <span class="d-flex flex-row flex-nowrap">
      <v-icon color="gray" class="mr-1" style="font-size: 20px;"
        >mdi-progress-question</v-icon
      >
      {{ playerInvitesUnknown.length }}
    </span>
  </div>
</template>
<script>
export default {
  name: "EventAvailabilitySummary",
  props: {
    playerInvitesYes: {
      type: Array,
      default: function() {
        return [];
      }
    },
    playerInvitesNo: {
      type: Array,
      default: function() {
        return [];
      }
    },
    playerInvitesUnknown: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
<style scoped>
.availability-wrapper {
  display: flex;
  flex-direction: row;
  padding: 10px 0;
}

.availability-label {
  font-size: 15px;
  font-weight: 500;
  min-width: 140px;
  display: inline-block;
  line-height: 25px;
}

.availability-label .v-icon {
  margin-top: -1px;
}

.availability-token {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  background-color: #ddd;
  padding: 5px 14px 5px 0px;
  border-radius: 20px;
  margin-bottom: 5px;
  margin-right: 5px;
  width: 150px;
}

.availability-token:hover {
  opacity: 0.8;
}

.availability-token .v-progress-circular {
  visibility: hidden;
}

.availability-token.loading {
  padding-left: 8px;
}

.availability-token.loading .v-progress-circular {
  visibility: visible;
}

.player-invite-name {
  white-space: nowrap;
  display: inline-block;
}

.player-invite-note {
  color: #666666;
  font-style: italic;
  font-size: 11px;
}

.availability-selectors {
  overflow: hidden !important;
}
</style>
